import api from '../../../../api/client'

export async function listRoles(params) {
  const { data } = await api.get('/roles/', { params })
  return data
}

export async function getRoleDetail(roleId) {
  const { data } = await api.get(`/roles/${roleId}`)
  return data
}

export async function createRole(payload) {
  const { data } = await api.post('/roles/', payload)
  return data
}

export async function updateRole(roleId, payload) {
  const { data } = await api.put(`/roles/${roleId}`, payload)
  return data
}

export async function cloneRole(roleId, payload) {
  const { data } = await api.post(`/roles/${roleId}/clone`, payload)
  return data
}

export async function archiveRole(roleId) {
  const { data } = await api.post(`/roles/${roleId}/archive`)
  return data
}

export async function deleteRole(roleId) {
  const { data } = await api.post(`/roles/${roleId}/delete`)
  return data
}

export async function listRolePrivileges(params) {
  const { data } = await api.get('/roles/privileges/all', { params })
  return data
}

export async function getPrivilegesTree() {
  const { data } = await api.get('/roles/privileges/tree')
  return data
}

export async function getDefaultPrivileges() {
  const { data } = await api.get('/roles/privileges/defaults')
  return data
}

